<template>
  <FlotoContentLoader :loading="loading">
    <MRow class="flex-1" :gutter="0">
      <MCol :sm="7" :size="12" class="px-2 flex flex-col">
        <h5 class="font-semibold">
          {{ $t('most_read') }}
        </h5>
        <FlotoCrudContainer
          :fetch-fn="fetchMostRead"
          :scrollable="false"
          as-table
          hide-table-headers
          :columns="tableColumns"
        >
          <template v-slot:name="{ item }">
            <td>
              <ResourceListTitle
                :name="item.name"
                :subject="item.subject"
                :created-at="item.updatedTime"
                :user-id="!isPortalLogin ? item.createdById : undefined"
                :link="
                  $currentModule.getRoute('read', { params: { id: item.id } })
                "
              />
            </td>
          </template>
          <template v-slot:thumbs="{ item }">
            <td>
              <FeedbackCount
                :positive-feedback="item.positiveFeedback"
                :negative-feedback="item.negativeFeedback"
              />
            </td>
          </template>
        </FlotoCrudContainer>
        <MDivider />
        <h5 class="font-semibold">
          {{ __t('most_helpful') }}
        </h5>
        <FlotoCrudContainer
          :fetch-fn="fetchMostHelpful"
          :scrollable="false"
          as-table
          hide-table-headers
          :columns="tableColumns"
        >
          <template v-slot:name="{ item }">
            <td>
              <ResourceListTitle
                :name="item.name"
                :subject="item.subject"
                :created-at="item.updatedTime"
                :user-id="!isPortalLogin ? item.createdById : undefined"
                :link="
                  $currentModule.getRoute('read', { params: { id: item.id } })
                "
              />
            </td>
          </template>
          <template v-slot:thumbs="{ item }">
            <td>
              <FeedbackCount
                :positive-feedback="item.positiveFeedback"
                :negative-feedback="item.negativeFeedback"
              />
            </td>
          </template>
        </FlotoCrudContainer>
      </MCol>
      <MCol
        :sm="5"
        :size="12"
        class="border-neutral-lighter border-solid border-l border-r-0 border-b-0 border-t-0 px-2"
      >
        <h5 class="font-semibold">{{ __t('most_searched_keywords') }}</h5>
        <MTag
          v-for="(keyword, index) in mostSearchKeyword"
          :key="index"
          :closable="false"
          variant="neutral-lighter"
          @click="$emit('keyword-selected', keyword)"
        >
          {{ keyword }}
        </MTag>
      </MCol>
    </MRow>
  </FlotoContentLoader>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import ResourceListTitle from '@components/resource/resource-list-title'
import { knowledgeAnalyticsApi } from '../knowledge-api'
import FeedbackCount from './feedback-count'

export default {
  name: 'Analytics',
  components: { ResourceListTitle, FeedbackCount },
  data() {
    this.columns = [
      {
        name: '',
        key: 'name',
        resizable: false,
      },
    ]
    return {
      loading: true,
      mostRead: [],
      mostHelpful: [],
      mostSearchKeyword: [],
    }
  },
  computed: {
    ...authComputed,
    tableColumns() {
      let c = this.columns
      if (!this.isPortalLogin) {
        c.push({
          name: '',
          key: 'thumbs',
          width: '150px',
        })
      }
      return c
    },
  },
  created() {
    knowledgeAnalyticsApi(this.isPortalLogin)
      .then((data) => {
        this.mostSearchKeyword = data.mostSearchKeyword
        this.mostRead = data.mostRead
        this.mostHelpful = data.mostHelpful
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    fetchMostRead() {
      return Promise.resolve({
        items: this.mostRead,
        total: this.mostRead.length,
      })
    },
    fetchMostHelpful() {
      return Promise.resolve({
        items: this.mostHelpful,
        total: this.mostHelpful.length,
      })
    },
  },
}
</script>
